// Time labels shared by every messaging surface (inbox rows, human threads,
// both concierge surfaces), so a date never reads differently across them.

const valid = (iso: string): Date | null => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** Under a bubble: "Sep 16, 6:43 PM". Empty for an unparsable value. */
export const formatMessageTime = (iso: string): string => {
  const d = valid(iso);
  return d ? d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";
};

/** Right edge of a conversation row: "6:43 PM" today, otherwise "Sep 16". */
export const formatListTime = (iso: string, now: Date = new Date()): string => {
  const d = valid(iso);
  if (!d) return "";
  const sameDay = now.toDateString() === d.toDateString();
  return sameDay
    ? d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })
    : d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
};
